// extracted by mini-css-extract-plugin
export var addressFields = "_hj-0";
export var animationContainer = "_hj-1";
export var footer = "_hj-2";
export var lineItems = "_hj-3";
export var modalContent = "_hj-4";
export var orderName = "_hj-5";
export var strong = "_hj-6";
export var warning = "_hj-7";